type BlobPart = BufferSource | Blob | string;

export function downloadBlob(data: BlobPart, type: string, filename: string, extension: string): void {
  const blob = new Blob([data], { type });
  const link = document.createElement('a');

  link.href = URL.createObjectURL(blob);

  link.download = `${filename}.${extension}`;
  link.click();
  URL.revokeObjectURL(link.href);
}
